// Texte des formules, indexé par CourseType puis CourseIntensity (voir app/data/pricing.ts).
const fr = {
  tierNames: {
    light: "Léger",
    semiIntensive: "Semi-intensif",
    intensive: "Intensif",
  },

  groupCourses: {
    light: {
      description: "Un cours accessible aux débutants, au rythme allégé.",
      features: [
        "Cours en direct en ligne une fois par semaine",
        "Séances de questions-réponses après chaque cours",
        "Accès aux séances enregistrées",
        "Conseils d'orientation tous les 3 mois",
        "Certificat de fin de formation",
        "Accès au groupe de la communauté",
        "Rapports de progression mensuels",
      ],
    },
    semiIntensive: {
      description:
        "Plus d'implication, avec des cours en direct supplémentaires et du contenu carrière.",
      features: [
        "Cours en direct en ligne deux fois par semaine",
        "Séances de questions-réponses après chaque cours",
        "Accès aux séances enregistrées",
        "Conseils d'orientation mensuels",
        "Préparation aux entretiens (tous les deux mois)",
        "Projets de groupe avec retours",
        "Supports et ressources d'apprentissage",
      ],
    },
    intensive: {
      description:
        "Le cours de groupe le plus immersif, avec un mentorat personnalisé.",
      features: [
        "Cours en direct en ligne quatre fois par semaine",
        "Séances de questions-réponses après chaque cours",
        "Accès aux séances enregistrées",
        "Conseils d'orientation toutes les deux semaines",
        "Préparation aux entretiens (mensuelle)",
        "Projets de groupe avec mentorat",
        "Webinaires et ateliers exclusifs",
      ],
    },
  },

  individualCourses: {
    light: {
      description:
        "Un cours flexible, avec des plans personnalisés et une interaction modérée.",
      features: [
        "Plan d'apprentissage personnalisé",
        "Cours en direct en ligne une fois par semaine",
        "Questions-réponses après chaque cours",
        "Accès aux séances enregistrées",
        "Conseils d'orientation tous les 3 mois",
        "Retours individuels sur vos projets",
        "Supports et ressources d'apprentissage",
      ],
    },
    semiIntensive: {
      description:
        "Une interaction individuelle plus fréquente et un mentorat d'expert.",
      features: [
        "Plan d'apprentissage personnalisé",
        "Cours en direct en ligne deux fois par semaine",
        "Questions-réponses après chaque cours",
        "Conseils d'orientation mensuels",
        "Mentorat de projet et retours d'expert",
        "Préparation aux entretiens (mensuelle)",
        "Supports d'apprentissage prioritaires",
      ],
    },
    intensive: {
      description:
        "Un programme tout-en-un, avec un mentorat et un soutien d'expert.",
      features: [
        "Plan d'apprentissage personnalisé",
        "Cours en direct en ligne quatre fois par semaine",
        "Questions-réponses après chaque cours",
        "Conseils d'orientation toutes les deux semaines",
        "Mentorat de projet approfondi",
        "Préparation aux entretiens (toutes les deux semaines)",
        "Support prioritaire par e-mail et par chat",
      ],
    },
  },
};

export default fr;
